"use client";

import { useContext } from "react";
import SliderContext from "../context";

const useSlider = () => {
  const context = useContext(SliderContext);

  if (!context) {
    throw new Error("useSlider must be used within a <Slider />");
  }

  return context;
};

export default useSlider;
